import * as React from 'react';
import { ChangeEvent, useCallback } from 'react';
import { MenuItem, Stack, TextField } from '@mui/material';

import { PropertyType } from '../models/Property';
import ValueLabel from '../models/ValueLabel';

interface TextQueryFormProps {
  relations?: Array<ValueLabel>;
  relationSelected?: ValueLabel;
  onChangeRelation?: (value: ValueLabel) => void;
  value?: string | number;
  onChangeValue?: (value: string) => void;
  maxValueLength?: number;
  type?: PropertyType;
}

const TextQueryForm = (props: TextQueryFormProps) => {
  const {
    relations = [],
    relationSelected,
    onChangeRelation,
    value,
    onChangeValue,
    maxValueLength = 100,
    type,
  } = props;

  const getInputType = React.useMemo(
    (): React.HTMLInputTypeAttribute => type?.toLowerCase(),
    [type]
  );

  const handleChangeRelation = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const relation = relations.find((r) => r.value === e.target.value);
      if (relation) {
        onChangeRelation?.(relation);
        return;
      }
      onChangeRelation?.({ value: '', label: '' });
    },
    [relations, onChangeRelation]
  );

  const handleChangeValue = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeValue?.(e.target.value);
    },
    [onChangeValue]
  );

  return (
    <Stack direction="column" gap={3} width={252}>
      <TextField
        id="search-filter-text-query-form-relative-input"
        label="Relative"
        size="small"
        select
        value={relationSelected.value}
        onChange={handleChangeRelation}
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        <MenuItem value="" style={{ display: 'none' }} />
        {relations.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        data-testid="search-filter-input-test-id"
        type={getInputType}
        size="small"
        placeholder="Search"
        value={value}
        onChange={handleChangeValue}
        inputProps={{
          maxLength: maxValueLength,
        }}
      />
    </Stack>
  );
};

export { TextQueryFormProps };
export default TextQueryForm;
